import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { createRouter, createWebHashHistory } from 'vue-router'
import Door from '../views/home/index.vue'
import Login from '../views/login/index.vue'
import Resetpass from '../views/login/resetpass.vue'
import Common from '../views/common/index.vue'
import MyConferences from '../views/common/MyConferences.vue'
import ActAcc from '../views/common/ActAcc.vue'
import ConferenceLogin from '../views/common/ConferenceLogin.vue'
import DetailPaper from '../views/common/DetailPaper.vue'
import DetailPaperprods from '../views/common/DetailPaperprods.vue'
import AboutUs from '../views/common/AboutUs.vue'
import SubmitPaper from '../views/common/SubmitPaper.vue'
import Contact from '../views/common/Contact.vue'
import Role from '../views/common/Role.vue'
import AuthorEmail from '../views/chairs/AuthorEmail.vue'
import SubmissionEmail from '../views/chairs/SubmissionEmail.vue'
import PaperDelete from '../views/chairs/PaperDelete.vue'
import PaperStatus from '../views/chairs/PaperStatus.vue'
import PaperPublish from '../views/chairs/PaperPublish.vue'
import DetailPublish from '../views/chairs/DetailPublish.vue'
import NewConference from '../views/chairs/NewConference.vue'
import ManagePapers from '../views/chairs/ManagePapers.vue'
import ProceedingsPapers from '../views/chairs/ProceedingsPapers.vue'
import ReviewEmail from '../views/chairs/ReviewEmail.vue'
import ProceedingsAdd from '../views/chairs/ProceedingsAdd.vue'
import ListPapers from '../views/contributor/ListPapers.vue'
import CreatePaper from '../views/contributor/CreatePaper.vue'
import ManageReview from '../views/reviewers/ManageReview.vue'
import My from '../views/person/my.vue'
import Message from '../views/person/message.vue'


const routes = [
  // 首页重定向到门户页面
  {
    path: '/',
    redirect: "/door"
  },
  // 登录注册页面
  {
    path: '/login',
    name: 'LoginReg',
    component: Login,
  },
  // 重置密码页面
  {
    path: '/resetpass',
    name: 'Resetpass',
    component: Resetpass,
  },
  // 门户页面
  {
    path: '/door',
    name: 'Door',
    component: Door,
  },
  // 普通用户页面
  {
    path: '/common',
    name: 'Common',
    component: Common,
    redirect: "/common/myconferences",
    children: [
      {
        path: 'actacc',
        name: 'actacc',
        component: ActAcc,
      },
      {
        path: 'newconference',
        name: 'newconference',
        component: NewConference,
      },

      {
        path: 'myconferences',
        name: 'myconferences',
        component: MyConferences,
      },
      {
        path: 'listpapers',
        name: 'listpapers',
        component: ListPapers,
      },
      {
        path: 'createpaper',
        name: 'createpaper',
        component: CreatePaper,
      },
      {
        path: 'detailpaper',
        name: 'detailpaper',
        component: DetailPaper,
      },
      {
        path: 'detailpaperprods',
        name: 'detailpaperprods',
        component: DetailPaperprods,
      },
      {
        path: 'aboutus',
        name: 'aboutus',
        component: AboutUs,
      },
      {
        path: 'detailpublish',
        name: 'detailpublish',
        component: DetailPublish,
      },   
      {
        path: 'managereview',
        name: 'managereview',
        component: ManageReview,
      },
      {
        path: 'conferencelogin',
        name: 'conferencelogin',
        component: ConferenceLogin,
      },
      {
        path: 'proceedingsadd',
        name: 'proceedingsAdd',
        component: ProceedingsAdd,
      },
      {
        path: 'managepapers',
        name: 'managepapers',
        component: ManagePapers,
      },
      {
        path: 'proceedingspapers',
        name: 'proceedingspapers',
        component: ProceedingsPapers,  
      },
      {
        path: 'submitpaper',
        name: 'submitpaper',
        component: SubmitPaper,
      },
      {
        path: 'contact',
        name: 'contact',
        component: Contact,   
      },
      {
        path: 'my',
        name: 'my',
        component: My,
      },
      {
        path: 'message',
        name: 'Message',
        component: Message
      },
      {
        path: 'role',
        name: 'Role',
        component: Role
      },
      {
        path: 'authoremail',
        name: 'authoremail',
        component: AuthorEmail
      },
      {
        path: 'submissionemail',
        name: 'submissionemail',
        component: SubmissionEmail
      },
      {
        path: 'paperdelete',
        name: 'paperdelete',
        component: PaperDelete
      },
      {
        path: 'paperstatus',
        name: 'paperstatus',
        component: PaperStatus
      },
      {
        path: 'paperpublish',
        name: 'paperpublish',
        component: PaperPublish
      },
      {
        path: 'reviewemail',
        name: 'reviewemail',
        component: ReviewEmail
      }
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})




router.beforeEach((to, from, next) => {
  // 获取 token
  let store = useStore()
  const token = store.state.user.token;
  // 登录页 登录或者注册才可以往下进行(未登录状态)
  if (to.path == '/login') {
    if (token != null) {
      next(from.path);
    } else {
      next();
    }
  }
  // 激活页面
  else if (to.path == '/common/actacc') {
    if (token != null) {
      next(from.path);
    } else {
      next();
    }
  }
  // 重置密码
  else if (to.path == '/resetpass') {
    next();
  }
  // 门户页
  else if (to.path == '/door') {
    next();
  }
  // token 不存在
  else {
    if (token == null) {
      ElMessage.warning({
        message: 'Please login to your account first',
        type: 'warning',
      })
      // 识别上一次访问的链接，登录后跳转过去
      if(to.query.conf){
        store.commit('setHistoryUrl',"/common/submitpaper?conf="+to.query.conf)
      }
      next('/login');
    } else {
      next()
    }
  }

})

export default router
